// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"766":"b1ca9eb1","919":"e1eaab05"}[chunkId] + ".chunk.css";
};